module.exports = __webpack_public_path__ + "img/Kids-Bedroom.f0e5faef.png";